import { observable } from 'mobx';

class FakturacniSubjekt {

    @observable public name: string;
    @observable public id: number;
    @observable public idSubjekt: number;
    @observable public idKlient: number;
    @observable public relationType: string;

    public clone(): FakturacniSubjekt {
        const newDen: FakturacniSubjekt = new FakturacniSubjekt();
        newDen.loadFromEntity(this);
        return newDen;
    }

    public loadFromJSON(json: any): FakturacniSubjekt {
        this.id = json.id;
        this.idKlient = json.id_klient;
        this.idSubjekt = json.id_subject;
        this.name = json.name;
        this.relationType = json.relation_type;
        return this;
    }

    public loadFromEntity(ent: FakturacniSubjekt): FakturacniSubjekt {
        this.id = ent.id;
        this.idKlient = ent.idKlient;
        this.idSubjekt = ent.idSubjekt;
        this.name = ent.name;
        this.relationType = ent.relationType;
        return this;
    }

}

export default FakturacniSubjekt;


// WEBPACK FOOTER //
// ./src/models/FakturacniSubjekt.tsx